<template>
  <canvas ref="canvas" class="canvas-border" @click="handleClick" />
</template>

<script>
import constants from "../../../../constants";

export default {
  name: "PDFPage",
  props: ["page"],
  data() {
    return {
      // canvas:null,
      // width:null,
      // height:null,
      clientWidth: null,
      scale: constants.DETAIL_DOCS_PAGE.PDF_DEFAULT_SCALE,
      coordinates: [],
      pageHeight: null
    };
  },
  mounted() {
    this.render();
  },
  methods: {
    getCanvasMeasurement() {
      return {
        canvasWidth: this.$refs.canvas.width,
        canvasHeight: this.$refs.canvas.height,
      };
    },
    measure() {
      this.$emit("onMeasure", {
        scale: this.scale,
        pageHeight: this.pageHeight
      });
    },

    handleClick(event) {
      const rect = this.$refs.canvas.getBoundingClientRect();
      const x = (event.clientX - rect.left) / this.scale;
      const y = (event.clientY - rect.top) / this.scale;
      this.$emit('onClick', { x, y });
    },

    async render() {
      const _page = await this.page;
      let canvas = this.$refs.canvas;
      const context = canvas.getContext("2d");
      const viewport = _page.getViewport({
        scale: this.scale
      });
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      this.pageHeight = viewport.height;
      await _page.render({
        canvasContext: context,
        viewport,
      }).promise;
      this.measure();
      window.addEventListener("resize", this.measure);
    },
  },
};
</script>

<style scoped lang="css">
.canvas-border {
  border: 1px solid #D4D4D4;
  border-radius: 7px;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/pdf-lib-contents/PDFPage.vue